import type { ReactElement } from 'react';

const ICONS = {
  play: 'M8 5v14l11-7z',
  pause: 'M6 5h4v14H6zM14 5h4v14h-4z',
  plus: 'M12 5v14M5 12h14',
  x: 'M6 6l12 12M18 6L6 18',
  check: 'M4 12l5 5L20 6',
  chev_r: 'M9 6l6 6-6 6',
  chev_l: 'M15 6l-6 6 6 6',
  chev_d: 'M6 9l6 6 6-6',
  cog: 'M12 9a3 3 0 100 6 3 3 0 000-6zm7.4 3a7.4 7.4 0 01-.1 1.2l2.1 1.6-2 3.4-2.4-1a7.4 7.4 0 01-2.1 1.2l-.4 2.6h-4l-.4-2.6a7.4 7.4 0 01-2.1-1.2l-2.4 1-2-3.4 2.1-1.6a7.4 7.4 0 010-2.4L4.5 8.2l2-3.4 2.4 1a7.4 7.4 0 012.1-1.2L11.4 2h4l.4 2.6a7.4 7.4 0 012.1 1.2l2.4-1 2 3.4-2.1 1.6c.1.4.2.8.2 1.2z',
  search: 'M11 4a7 7 0 105.3 11.7l4 4 1.4-1.4-4-4A7 7 0 0011 4zm0 2a5 5 0 110 10 5 5 0 010-10z',
  flame: 'M12 2s4 4 4 8a4 4 0 11-8 0c0-1 .3-2 .5-2.5C7 10 6 12 6 14a6 6 0 0012 0c0-4-3-7-6-12z',
  clock: 'M12 2a10 10 0 100 20 10 10 0 000-20zm1 5h-2v6l5 3 1-1.7-4-2.3V7z',
  star: 'M12 3l2.6 5.8 6.4.6-4.8 4.4 1.4 6.2L12 17l-5.6 3 1.4-6.2L3 9.4l6.4-.6L12 3z',
  signal: 'M3 20h4V10H3v10zm7 0h4V4h-4v16zm7 0h4v-7h-4v7z',
  music: 'M9 17V5l10-2v12M9 17a3 3 0 11-3-3 3 3 0 013 3zm10-2a3 3 0 11-3-3 3 3 0 013 3z',
  trash: 'M5 7h14M10 7V4h4v3M7 7l1 13h8l1-13M10 11v6M14 11v6',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3zM19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9L19 15z',
  home: 'M3 12l9-8 9 8v8a2 2 0 01-2 2h-4v-6h-6v6H5a2 2 0 01-2-2v-8z',
  book: 'M4 4h10a3 3 0 013 3v13H7a3 3 0 01-3-3V4zm3 0v13M17 7h3v13H7',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  bell: 'M6 16V11a6 6 0 1112 0v5l2 3H4l2-3zM10 20a2 2 0 004 0',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-4 0-8 2-8 6h16c0-4-4-6-8-6z',
  arr_l: 'M19 12H5M12 19l-7-7 7-7',
  arr_r: 'M5 12h14M12 5l7 7-7 7',
  arr_u: 'M12 19V5M5 12l7-7 7 7',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7l1-8z',
  heart: 'M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zm10 3a3 3 0 100-6 3 3 0 000 6z',
  link: 'M10 14a5 5 0 006.5.5l3-3a5 5 0 00-7-7l-1 1M14 10a5 5 0 00-6.5-.5l-3 3a5 5 0 007 7l1-1',
  tag: 'M3 12V3h9l9 9-9 9-9-9zm5-5a2 2 0 100 4 2 2 0 000-4z',
  calendar: 'M4 6h16v14H4zM4 6V4M8 4v4M16 4v4M20 6V4M4 10h16',
  mic: 'M12 2a3 3 0 013 3v6a3 3 0 11-6 0V5a3 3 0 013-3zm-7 9a7 7 0 0014 0M12 18v4M8 22h8',
  google: 'M21.8 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.5a4.7 4.7 0 01-2 3.1v2.6h3.3a10 10 0 003-7.5zM12 22c2.7 0 5-1 6.6-2.5l-3.3-2.6a6 6 0 01-9-3.1H2.9v2.7A10 10 0 0012 22zm-5.7-7.6a6 6 0 010-3.8V8H2.9a10 10 0 000 8l3.4-2.7zM12 6a5.4 5.4 0 013.8 1.5l2.9-2.8A10 10 0 002.9 8l3.4 2.7A6 6 0 0112 6z',
  apple: 'M17.6 12.8c0-3 2.5-4.5 2.6-4.5-1.4-2-3.6-2.3-4.4-2.3-1.9-.2-3.6 1.1-4.6 1.1-.9 0-2.4-1-4-1C5.4 6.1 3.3 7.5 2.2 9.6c-1.8 3-.5 7.4 1.3 9.8 1 1.1 2 2.4 3.4 2.4 1.3 0 1.9-.9 3.5-.9s2.1.9 3.5.8c1.5 0 2.4-1.2 3.3-2.3a10 10 0 001.5-3.1c-.1 0-3-1.1-3-4.5zM14.7 4a4.8 4.8 0 001.1-3.4c-1.1 0-2.4.7-3.2 1.6A4.5 4.5 0 0011.5 5c1.2.1 2.4-.6 3.2-1z',
  wave: 'M2 12h3l2-6 3 12 3-8 2 5 2-3h5',
  menu: 'M4 7h16M4 12h16M4 17h16',
  share: 'M18 8a3 3 0 10-3-3v.2L8.8 9A3 3 0 106 13c.6 0 1.2-.2 1.7-.5l7 4.1V17a3 3 0 103-3 3 3 0 00-2.3 1.2L8.9 11l.2-.4L15.7 6.8A3 3 0 0018 8z',
  filter: 'M4 5h16l-6 8v6l-4-2v-4L4 5z',
  sliders: 'M4 6h12M18 6h2M4 12h2M8 12h12M4 18h12M18 18h2M17 4v4M7 10v4M17 16v4',
  book_open: 'M12 6s-2-2-5-2-5 2-5 2v13s2-2 5-2 5 2 5 2m0-13s2-2 5-2 5 2 5 2v13s-2-2-5-2-5 2-5 2m0-13v13',
  // Half-filled star: same outline as `star`, plus a vertical bisecting move so the
  // filled paint covers only the left half. Filled icon — matches `star`.
  star_half: 'M12 3l2.6 5.8 6.4.6-4.8 4.4 1.4 6.2L12 17l-5.6 3 1.4-6.2L3 9.4l6.4-.6L12 3zM12 3v14',
  // Outline tray icons mirroring lucide-react's download/upload paths.
  download: 'M12 15V3 M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5',
  upload: 'M12 3v12 M17 8l-5-5-5 5 M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4',
  // Shield outline mirroring lucide-react's Shield path.
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
} as const;

export type IconName = keyof typeof ICONS;

const FILLED: readonly IconName[] = [
  'flame', 'play', 'pause', 'star', 'star_half', 'music', 'sparkle',
  'heart', 'tag', 'bolt', 'home', 'book', 'book_open', 'google', 'apple',
];

export type IconProps = {
  name: IconName;
  size?: number;
  className?: string;
  strokeWidth?: number;
};

export function Icon({ name, size = 16, className = '', strokeWidth }: IconProps): ReactElement | null {
  const d = ICONS[name];
  if (!d) return null;
  const filled = FILLED.includes(name);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={strokeWidth ?? 1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0 }}
    >
      <path d={d} />
    </svg>
  );
}
